import { colors } from '@ajaibid/components';
import { css } from '@emotion/css';

export const styOrderBookSectionContainer = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
`;

export const styOrderBookColumn = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const styOrderBookItem = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const styOrderBookInfoContainer = css`
  gap: 36px;
  margin-top: 14px;
`;

export const styOrderBookInfoItem = css`
  font-size: 12px;
  line-height: 1.5;
  color: ${colors.NEUTRAL_7};

  .item-value {
    font-weight: 700;
  }
`;

export const styOrderBookRunningContainer = css`
  gap: 4px;
  margin-top: 27px;
`;

export const styOrderBookRunningHeader = css`
  padding: 4px 8px;
  background-color: ${colors.NEUTRAL_1};
  border-radius: 4px;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.NEUTRAL_9};
`;

export const styOrderBookItemGap = css`
  gap: 2px;
`;

const openOrderIndicator = () => css`
  content: '';
  position: relative;
  top: -1px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${colors.MARKET_COLOR_GREY};
`;

/**
 * @param { GREEN_5 | RED_5 | NEUTRAL_9 } priceIndicator - color of price indicator
 * @param { "left" | "right" } volumeIndicatorPosition - position of volume indicator
 * @param { number } volume - volume of order
 * @returns
 */
export const styOrderBookRunningItem = (priceIndicator, volumeIndicatorPosition, volume) => css`
  padding: 4px;
  position: relative;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    width: ${volume ? `${volume}%` : '0'};
    height: 100%;
    background-color: ${volumeIndicatorPosition === 'right' ? `${colors.GREEN_5}` : `${colors.RED_5}`};
    opacity: 0.17;
    transition: width 0.3s ease;

    ${volumeIndicatorPosition === 'left' ? 'left: 0;' : 'right: 0;'}
  }

  .item-lot {
    font-size: 12px;
    line-height: 1.5;
    color: ${colors.NEUTRAL_9};
    font-weight: 400;
  }

  .item-price {
    font-size: 14px;
    line-height: 1.5;
    color: ${priceIndicator};
    font-weight: 700;

    /* &::before {
      display: ${volumeIndicatorPosition === 'right' ? 'inline-block' : 'none'};
      ${openOrderIndicator()}
      margin-right: 4px;
    }

    &::after {
      display: ${volumeIndicatorPosition === 'left' ? 'inline-block' : 'none'};
      ${openOrderIndicator()}
      margin-left: 4px;
    } */
  }
`;
